import CustomSettings from "./components/CustomSettings";

export const routes = [
  {
    path: "/customsettings",
    exact: true,
    component: CustomSettings,
    name: "CustomSettings"
  }
];
